/* eslint-disable import/no-unresolved */
// noinspection ES6CheckImport

import { initConfig } from '@finn-no/huck-config'
import { initApp } from './main'

const appElement = '#footer'
initConfig(appElement)

const init = () => {
  const injectedState = window.INITIAL_DATA
  const { app } = initApp(injectedState)
  app.mount(appElement)
}

init()
